module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';
	fox.registerWidget('PreviewUploadedContent', {

		configure: function () {
			this.STORE = {};

			this.registerOptions('', {
				useUiPosition: true,
				preventHideOnShadowClick: false,
				template: '',
				'dialog.dialogClass': 'preview-content',
				'dialog.autoOpen': false,
				'dialog.closeText': '',
				'dialog.width': '100%',
				'dialog.minHeight': 300,
				'dialog.open': fox.bind(function () {
					var
						navBtn = $('<span></span>').addClass('nav-arrows').on('click', fox.bind(this.navigate, this)),
						$dialog = this.dialogMethod('widget'),
						$btns = $dialog.find('.nav-arrows');

					if (!$btns.length) {
						$dialog
							.append(navBtn.clone(true).addClass(this.getOption('leftNavArrow')).data('direction', 'prev'))
							.append(navBtn.clone(true).addClass(this.getOption('rightNavArrow')).data('direction', 'next'));		
					
						$btns = $dialog.find('.nav-arrows');
					}
					
					$btns.each(fox.bind(function (indx, el) {
						$(el)[this.collection.length > 1 ? 'show' : 'hide']();
					}, this));

					// add blur to wrapper
					$(fox.dom.selectFirst('.wrapper')).addClass('blured');
				}, this),
				'dialog.close': fox.bind(function () {
					var player = this.rwom1('#videoPreview')._player; 
					if (!!player) {
						this.rwom1('#videoPreview')._player.pause();
					}
					$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
					
				}, this),
				widgets: {
					videoPreview: {
						widget: 'Content_Html5Player',
						container: '.flash-player-container',
						getMapMethod: 'Client_Upload.getMap',
						disableTimeline: true,
						template: 'preview_attached_content_video',
						renderPlayer: true,
						renderTo: '#flash-player',
						resourceIdParamName: 'clientUploadId',
						jsonizeMapRequest: false,
						'hooks.onStartRendering': function() {
							var
								parent = this.getParent(),
								id = parent.currentId;
							this.setTemplateOptions({
								contentId: id,
								targetId: parent.currentResId,
								attachTitle: parent.currentData.attachTitle
							});
						},
						'widgets.downloadLinks': {
							widget: 'Widget',
							autoRender: true,
							template: 'attached_video_download_links',
							
							'embed.container': '.attach-download',
							'hooks.onStartRendering': function () {
								var
									parent = this.getParent().getParent(),
									id = parent.currentId,
									vData = parent.STORE[id];

								this.setTemplateOptions({
									downloadLink: vData.download[fox.getObjectKeys(vData.download)].link
								});
							},
							handleDom: {
								// showDownList: {
								// 	event: 'click',
								// 	target: '.download',
								// 	callback: function (elem) {
								// 		var container = this.getOption('container');
								// 		var activeClass = this.getOption('activeClass');
								// 		var activeItems = this.getOption('activeItems');

								// 		$(elem).toggleClass('active');
								// 		$('.download-links').toggleClass('active');

								// 		if (activeItems) {
								// 			$('.download-links').find('li').toggleClass('active');
								// 		}
								// 	}
								// },
								handleDownload: {
									event: 'click',
									target: '.download',
									callback: function (el) {
										var api = this.getApi('log', {method: 'logger.log'});
										api.send({
											index: 'McUserActivity',
											path: fox.Navigator.getAll(),
											info: {event: 'download'}
										}, false);
									}
								}
							}
						}
					},
					imagePreview: {
						widget: 'Widget',
						template: 'preview_attached_content_image',
						handleDom: {
							downloadPhoto: {
								target: '.download',
								callback: '@parent:downloadPhoto'
							}
						},
						'hooks.onStartRendering': function () {
							var
								parent = this.getParent();

							this.setTemplateOptions({
								imageSrc: parent.currentData.bigThumb,
								attachTitle: parent.currentData.attachTitle,
								contentId: parent.currentId,
								resourceId: parent.currentResId
							});

							return true;
						}
					}
				},
				handleWom: {
					playerStart: {
						event: 'playerRunning',
						widget: '#videoPreview',
						callback: function (params, player, alias) {
							this._center();
						}
					}
				}
			});

			this.registerOptions('.Widget', {
				'embed.container': '.ui-dialog-content',
				autoRender: false,
				active: false,
				group: 'contentPreview',
				'widgets.favorite': {
					widget: 'Social_Favorite',
					subject: 'resource',
					'embed.widget': '@parent'

				},
				'hooks.onStopRendering': this.contentOnStopRendering
			});
		
			this.callParent('configure', arguments);
		},

		running: function () {
			var vp = this.rwom1('#videoPreview'), _this = this;

			// vp._readyToRender = false;
			// this.rwom1('#imagePreview')._readyToRender = false;

			var spm = vp.setPlayerSize;

			vp.setPlayerSize = function () {
				spm.apply(vp, arguments);

				_this._center();
			};
		
			this.callParent('running', arguments);
		},

		show: function (params) {
			this.collection = function () {return params.collection;}.call(this);

			if (!fox.isEmpty(params.data)) {
				this.showPopupContent(params.data);

				if (!this.isOpen()) {
					this.callParent('show', arguments);
				}
			}
		},

		showPopupContent: function (params) {
			if (this.currentId !== params.id) {
				this.currentData = params;
				this.setCurrentId(params.id);
				this.currentResId = params.resId;

				if (this.currentData.type === 1 && !this.STORE[this.currentId]) {
					this.fillStore(this.currentId, this.currentData.videoData);
				}

				this.switchType(params.type).then(function () {
					this.renderContentPreview();
				}.bind(this));
			}
		},

		getActivePreview: function () {
			var 
				aw;

			fox.each(this.getWidgetsByGroup('contentPreview'), function (w, alias) {
				if (w.isActive()) {
					aw = w;

					throw fox.break;
				}
			});

			return aw;
		},

		renderContentPreview: function () {
			var w = this.getActivePreview();
			var promise = w.wait('addedToDom').then(function () {
				// w._readyToEmbed = false;

				var vData = this.STORE[this.currentId];
				if (!!vData) {
					w.preparePlayerData(vData);
				}

				w.setPoster(this.currentData.posterUrl);
			}.bind(this));

			// w._readyToEmbed = true;

			w.render();

			this.loadFavoriteStatus(w);

			return promise;
		},

		loadFavoriteStatus: function (preview) {
			var f = preview.rwom1('.Social_Favorite');

			f.targetIds = [this.currentResId];

			f.loadData();

			return this;
		},

		setCurrentId: function (id) {
			if (id !== undefined && this.currentId !== id) {
				this.currentId = id;
			}

			return this;
		},

		fillStore: function (id, data) {
			if (!this.STORE.hasOwnProperty(id) && data !== undefined) {
				this.STORE[id] = data;
			}

			return this.STORE[id];
		},

		switchType: function (type) {
			var targetAlias = type === 1 ? 'videoPreview' : type === 2 ? 'imagePreview' : '';
			var promise = this.wait('switchedEmbeddedWidget');

			return this.switchEmbeddedWidget(targetAlias) && promise || fox.Promise.resolve(true);
		},

		getMapResponse: function (res) {
			var 
				map = this.fillStore(this.currentId, res.answer.response),
				p = this.rwom1('#videoPreview');

			p.preparePlayerData(map);
		},

		navigate: function (e) {
			var
				d = $(e.target).data('direction'),
				collection = this.collection,
				indx = collection.indexOf(collection.filter(function (v) {
					return v.id === this.currentId && v.messageId === this.currentData.messageId;
				}, this).pop());

			if (indx !== -1) {
				indx = (d === 'prev') ? indx - 1 : (d === 'next') ? indx + 1 : indx;

				if (collection[indx] !== undefined) {
					this.showPopupContent(collection[indx]);
				} else if (indx === -1) {
					this.showPopupContent(collection[collection.length - 1]);
				} else if (indx === collection.length) {
					this.showPopupContent(collection[0]);
				}
			}
		},

		contentOnStopRendering: function () {
			this.getParent().toggleDownload(this);
		},

		toggleDownload: function (w) {
			var
				attachType = this.currentData.type,
				attachPaid = Number(this.currentData.paid) > 0,
				showStatus,
				$el
			;

			switch (attachType) {
				case 1:
					showStatus = fox.getEnv(attachPaid === true ? 'contentAccessCommon.attachVideosPaidDownloadable' : 'contentAccessCommon.attachVideosDownloadable' );
				break;
				case 2:
					showStatus = fox.getEnv(attachPaid === true ? 'contentAccessCommon.attachPhotosPaidDownloadable' : 'contentAccessCommon.attachPhotosDownloadable');
				break;
			}

			if (showStatus === 0) {
				$el = $(w.dom1('.attach-download'));

				return $el.length && $el.remove();
			}
		},

		downloadPhoto: function (el, alias, w, e) {
			e.preventDefault();

			var _this = this;
			var transport = new XMLHttpRequest();

			transport.open('GET', el.href);
			transport.responseType = 'blob';
			
			transport.onload = function () {
				var a = document.createElement('a');
				var fname = _this.currentData.attachTitle.replace(/(\s-\s|\s|\.)/g, '_') + '.jpg';

				if (navigator.msSaveBlob) {
					return navigator.msSaveBlob(transport.response, fname);
				}

				if (window.URL || typeof safari !== 'undefined') {
					a.href = window.URL.createObjectURL(transport.response);
					a.setAttribute('download', fname);
					document.body.appendChild(a);

					setTimeout(function () {
						a.click();

						document.body.removeChild(a);
					}, 100);

					return true;
				}
			};

			transport.send();
		},

	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/conversation/previewContent.js
// module id = 832
// module chunks = 4